import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../../../services/ApiService"

// ⚠️ Remplacement de IntlMessage
import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"

import moment from 'moment'
import PermissionAlert from "../../../components/permissions/PermissionAlert";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalDeletePaiement extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initstate = {
        visible: false,
        loading: false,
        id: null
    };

    state = this.initstate

    async show(id) {
        console.log("PAYEMENT DELETE ", id)

        this.setState({visible: true, id: id})
    }

    close() {
        this.setState(this.initstate)
    }

    async onFinish(data) {
        console.log(data)

        var res = await ApiService.post("/paiements/cerfa/delete/" + this.state.id, {deletedMessage: data.deletedMessage})
        console.log(res)

        if (res.success) {
            notification.success({
                message: t`Suppression effectuée avec succès`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: t`Erreur lors de la suppression`
            })
        }
    }


    render() {
        return (
            <Fragment>
                <Modal
                    width={"100%"}
                    style={{minHeight: 500}}
                    title={t`Êtes-vous sûr de vouloir supprimer ce paiement ?`}
                    open={this.state.visible}
                    destroyOnClose
                    closable
                    footer={null}
                    onCancel={() => this.close()}
                >
                    <PermissionAlert permissions={["paiement.delete"]}>
                        <Form onFinish={(data) => this.onFinish(data)}>
                            <Form.Item
                                name="deletedMessage"
                                label={t`Préciser la raison`}
                                required
                            >
                                <Input.TextArea/>
                            </Form.Item>

                            <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                    <Trans>Valider</Trans>
                                </Button>
                            </Form.Item>
                        </Form>
                    </PermissionAlert>
                </Modal>
            </Fragment>
        )
    }
}
